const filter = {


    init: function(container = document){

        $('.type-list-js input').each(function() {
            let $this = $(this);
            $this.on('click', function() {
                let $this = $(this);
                let checked = $this.data('checked');
                if(checked == 'true') {
                    $this.prop('checked', false);
                    $this.data('checked', 'false');

                    $filter.submit();
                    return;
                }
                $('.type-list-js input').data('checked', 'false');
                $this.data('checked', 'true');
            });
        })
        
        $('.house-select').each(function() {
            let $this = $(this);
            let f = $this.data('for');
            if($(`#${f}`).is(":checked")) {
                $this.addClass('clicked');
            }
        });

        let $filter = $(container).find('.filter-form');
        let $houses = $filter.find('.house-select');
        let $specials = $filter.find('.item-special');
        let $sliders = $filter.find('.slider');
        let $inputs = $filter.find('.filter-inputs input, .filter-extra input, .type-list-js input');
        let $list = $('.table-container');

        $inputs.on('change', function(){
            $filter.submit();
        })

        if($sliders.length > 0 ){
            $.each($sliders, function(){
                let $this = $(this);
                $this.ionRangeSlider({
                    type: "double",
                    hide_min_max: true,
        
                    onFinish: function(data){
                        if(data.min != data.from){
                            $(data.slider).find('.irs-handle.from').addClass('state_changed');
                        }else{
                            $(data.slider).find('.irs-handle.from').removeClass('state_changed');
                        }

                        if(data.max != data.to){
                            $(data.slider).find('.irs-handle.to').addClass('state_changed');
                        }else{
                            $(data.slider).find('.irs-handle.to').removeClass('state_changed');
                        }

                        $filter.submit();
                    },
                    prettify: function (num) {
                        return numberWithSpace(num);
                    }
                });
            })
        }

        $filter.submit(function(e){
            e.preventDefault();
            let $this  = $(this);
            $.ajax({
                url:$this.attr('action'),
                data: $this.serialize(),
                type: 'POST',
                beforeSend: function(){ }
            }).done(function(data){
                //console.log(data);
                data = JSON.parse(data);
            
                if($( window ).width() <= 767) {
                    let $mob = $('#refresh-filter-mob');
                    if(data.html.includes('refresh-filter js-refresh-filter')) {
                        $mob.css({display: 'none'});
                    } else {
                        $mob.css({display: 'block'});
                    }
                }

                if($list.length > 0){
                    $list.html(data.html);
            
                    favorite.updateTable($list);
                }
                let url = window.location.href;
                url = url.split('?');
                barba.history.add(url[0]+'?'+data.query, 'filter');
                triggerResize();

                let $reset = $list.find('.btn-reset');

                if($reset.length >0){
                    console.log($reset);
                }

            });
        });


        $houses.on('click', function(){
            let $this = $(this);
            let $input = $filter.find('#'+$this.data('for'));
            $this.toggleClass('clicked');
            if($input.prop('checked') === false){
                $input.prop('checked',true);
            }else{
                $input.prop('checked',false);
            }

            $filter.submit();

        });

        $specials.on('click', function(){
            $filter.submit();
        });


        let $toggle = $(container).find('.filter-toggle');

        $toggle.on('click', function(){
            $(this).toggleClass('full');
            $filter.slideToggle();
        })

    },
    submit: function(container = document) {
        let $filter = $(container).find('.filter-form');
        $filter.submit();
    }

}

function triggerResize(){
    var resizeEvent = window.document.createEvent('UIEvents');
    resizeEvent.initUIEvent('resize', true, false, window, 0);
    window.dispatchEvent(resizeEvent);
}

filter.init();